import { format } from "date-fns";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import PWLCalendarComponent from "@/app/components/ui/Calendar/PWLCalendar";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useOrderManagementClinicListAPI } from "@/app/hooks/api_hooks/orders/useOrderClinicListAPI";
import { useUserHairCutBathServicesAPI } from "@/app/hooks/api_hooks/bookings/useUserHairCutBathServicesAPI";
import { useOverBookingsGroomerListAPI } from "@/app/hooks/api_hooks/bookings/useOverBookingsGroomersListAPI";
import { useOverBookingHairCutToBathAPI } from "@/app/hooks/api_hooks/bookings/useOverBookingHairCutToBathPostAPI";

export interface IBookingHairCutFormFields {
  clinics: string;
  date: string;
  provider: string;
  service: any;
}

const HaircutToBath = () => {
  const clinicListAPI = useOrderManagementClinicListAPI();
  const fetchHairCutProviders = useOverBookingsGroomerListAPI();
  const postHairCutToBath = useOverBookingHairCutToBathAPI();
  const haircutServices = useUserHairCutBathServicesAPI();
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ORDER_MANAGEMENT", "id");
  const { routeState } = useRouteInfo(routeId);
  const routeIdSlot = getRouteKey("SLOTS", "id");
  const { routeState: providerList } = useRouteInfo(routeIdSlot);
  const clinicsOrg = routeState?.state?.clinicList?.results;
  const providerListHairCut = providerList?.state?.haircutGroomer;
  const haircutServicesItems = providerList?.state?.haircutServices;
  const clinicsOrgItem = useSelectMenuReducer(clinicsOrg, "name", "id");
  const servicesItem = useSelectMenuReducer(haircutServicesItems, "sub_service_name", "sub_service_id");
  const providerItem = useSelectMenuReducer(providerListHairCut, "name", "id");

  const formHook = useForm<IBookingHairCutFormFields>({
    mode: "onChange",
    defaultValues: {},
  });

  useEffect(() => {
    clinicListAPI();
    haircutServices();
  }, []);

  const handelClick = () => {
    formHook.trigger();
    const form_data = formHook.getValues();
    const constructedBody = {
      clinic_id: form_data?.clinics,
      date: form_data?.date,
      staff_id: form_data?.provider,
      sub_service_ids: [form_data?.service],
    };
    postHairCutToBath(constructedBody);
  };

  const handelPermisionButton = () => {
    const form_data = formHook.getValues();
    if (form_data.clinics && form_data.date && form_data.provider && form_data.service) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div>
      <h2 className="text-black text-base font-semibold py-4 px-3 rounded-md shadow-md">Use Haircut as Bath</h2>
      <div className="w-2/4 mt-4 mx-auto p-4 rounded-lg shadow-lg border border-gray-50">
        <table className="w-full">
          <tr>
            <td className="w-1/4 py-3 text-xs font-medium">Select Clinic</td>
            <td className="py-3">
              <SearchableSelectMenu
                errorMessages={[{ message: "Clinic is required", type: "required" }]}
                onSelectItem={(item) => {
                  if (item) {
                    formHook.setValue("clinics", item.id);
                    fetchHairCutProviders(formHook.getValues("clinics"));
                  }
                }}
                fieldError={formHook.formState.errors.clinics}
                register={formHook.register("clinics", { required: true })}
                selectItems={clinicsOrgItem}
                placeholder="Select Clinics"
                showTooltips={false}
                showTypedErrors={false}
                showDropdownIcon={true}
                defaultSelected={clinicsOrgItem?.filter((oc) => oc.id === formHook.watch("clinics"))[0]}
                listBoxClassName="w-full"
                className="text-gray-800"
                containerClassName="w-full"
              />
            </td>
          </tr>
          <tr>
            <td className="w-1/4 py-3 text-xs font-medium">Select Date</td>
            <td className="py-3">
              <PWLCalendarComponent
                showLeftNav={false}
                errorMessages={[{ message: "Date is required", type: "required" }]}
                register={formHook.register("date", {
                  required: true,
                })}
                fieldError={formHook.formState.errors.date}
                onSelectDate={(date) => {
                  formHook.setValue("date", format(date, "yyyy-MM-dd"));
                }}
                className="w-full"
              />
            </td>
          </tr>
          <tr>
            <td className="w-1/4 py-3 text-xs font-medium">Select Provider</td>
            <td className="py-3">
              <SearchableSelectMenu
                errorMessages={[{ message: "Clinic is required", type: "required" }]}
                onSelectItem={(item) => {
                  if (item) {
                    formHook.setValue("provider", item.id);
                  }
                }}
                fieldError={formHook.formState.errors.provider}
                register={formHook.register("provider", { required: true })}
                selectItems={providerItem}
                placeholder="Select Provider"
                showTooltips={false}
                showTypedErrors={false}
                showDropdownIcon={true}
                defaultSelected={providerItem?.filter((oc) => oc.id === formHook.watch("provider"))[0]}
                listBoxClassName="w-full"
                className="text-gray-800"
                containerClassName="w-full"
              />
            </td>
          </tr>
          <tr>
            <td className="w-1/4 py-3 text-xs font-medium">Select Services</td>
            <td className="py-3">
              <SearchableSelectMenu
                errorMessages={[{ message: "Clinic is required", type: "required" }]}
                onSelectItem={(item) => {
                  if (item) {
                    formHook.setValue("service", item.id);
                  }
                }}
                fieldError={formHook.formState.errors.service}
                register={formHook.register("service", { required: true })}
                selectItems={servicesItem}
                placeholder="Select service"
                showTooltips={false}
                showTypedErrors={false}
                showDropdownIcon={true}
                defaultSelected={servicesItem?.filter((oc) => oc.id === formHook.watch("service"))[0]}
                listBoxClassName="w-full"
                className="text-gray-800"
                containerClassName="w-full"
              />
            </td>
          </tr>
        </table>
        <div className="mt-6 w-full">
          <button
            disabled={handelPermisionButton()}
            className={`py-3 cursor-pointer text-sm w-full ${
              !handelPermisionButton() ? "bg-[#193A6A]" : "bg-gray-400"
            } text-white font-semibold rounded-md`}
            onClick={handelClick}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default HaircutToBath;
